import React, { useState } from 'react';
import EditDetails from './edit-details';
import ViewDetails from './view-details';
import { MemberListType } from 'models/member.model';
import { SideModal } from '@cokitchen/cokitchen-components';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  singlePeople?: MemberListType;
  setSelectedPeople: (value: MemberListType[]) => void;
  onRefresh: () => void;
  updatePerson: (newData: MemberListType) => void;
  previousPage: string;
};

const MemberDetails = ({
  isOpen,
  onClose,
  singlePeople,
  setSelectedPeople,
  onRefresh,
  updatePerson,
  previousPage
}: Props) => {
  const [editMode, setEditMode] = useState(false);
  return (
    <SideModal
      closeBtnVariant='side'
      bodyClassName='w-[98vw] sm:w-[450px]'
      showTopNavbar
      isOpen={isOpen}
      onRequestClose={() => {
        onClose();
        setEditMode(false);
        setSelectedPeople([]);
      }}>
      {editMode ? (
        <EditDetails
          setEditMode={setEditMode}
          singlePeople={singlePeople}
          onClose={onClose}
          setSelectedPeople={setSelectedPeople}
          updatePerson={updatePerson}
          onRefresh={onRefresh}
          previousPage={previousPage}
        />
      ) : (
        <ViewDetails setEditMode={setEditMode} singlePeople={singlePeople} />
      )}
    </SideModal>
  );
};

export default MemberDetails;
